/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Label_Needs_ApprovalInputs */

const en_wb_label_needs_approval = /** @type {(inputs: Wb_Label_Needs_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Needs your approval`)
};

const lv_wb_label_needs_approval = /** @type {(inputs: Wb_Label_Needs_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepieciešams Jūsu apstiprinājums`)
};

/**
* | output |
* | --- |
* | "Needs your approval" |
*
* @param {Wb_Label_Needs_ApprovalInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_label_needs_approval = /** @type {((inputs?: Wb_Label_Needs_ApprovalInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Label_Needs_ApprovalInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_label_needs_approval(inputs)
	return en_wb_label_needs_approval(inputs)
});